import {Component, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {UtilsService} from "../../../core/utils/utils.service";
import {FormControl, FormGroup} from "@angular/forms";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {AtelierDTO} from "../../../core/dtos/atelier-d-t-o";
import {AteliersService} from "../../../core/services/entities/ateliers.service";

@Component({
  selector: 'yo-atelierDialog',
  templateUrl: './atelier-dialog.component.html',
  styleUrls: ['./atelier-dialog.component.scss']
})
export class AtelierDialogComponent implements OnInit {

  subOpenDialog: Subscription

  atelier: AtelierDTO;

  form: FormGroup = new FormGroup({});

  dialogTitle: String = 'Modification d\'un atelier';

  sitePlaceholder: String = 'Selectionner le site...';

  displayDialog = false;

  idSelectedSite: number;

  constructor(private auth2Svc: Auth2Service,
              private toastSvc: ToastService,
              public ateliersSvc: AteliersService,
              public utilsSvc: UtilsService) {
  }

  ngOnInit() {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.ateliersSvc.openDialogEdition$
      .subscribe((cdt: AtelierDTO) => {
        this.displayDialog = true;
        if (!cdt) {
          this.atelier = new AtelierDTO();
          this.atelier.id = 0;
          this.dialogTitle = 'Création d\'un atelier';
        } else {
          this.atelier = cdt;
          this.dialogTitle = 'Modification d\'un atelier';
        }
        this.initForm();
      });
  };

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

  save = (): void => {
    if (this.form.valid) {
      let newAtelier: AtelierDTO = {...this.atelier};
      newAtelier.site = {id: this.idSelectedSite} as SiteDTO;
      newAtelier.libelle = this.form.controls['libelle'].value;
      newAtelier.actif = this.form.controls['actif'].value;
      this.ateliersSvc.save(newAtelier)
        .subscribe(response => {
          const isUpdate = newAtelier.id !== null && newAtelier.id !== undefined && newAtelier.id !== 0;
          this.ateliersSvc.announceAtelierSaved(response.one, isUpdate);
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde de l'atelier réalisée avec succès`);
          this.closeDialog();
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.atelier?.site?.libelle : 'Selectionner le site...';
    this.idSelectedSite = this.atelier?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.atelier?.libelle),
      actif: new FormControl(this.atelier?.actif != null ? this.atelier.actif : true)
    });
  };

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event.selectedItem?.id;
  }

  canModify = () => {
    return this.ateliersSvc.canModify(this.atelier);
  }

}
